﻿export class FileUploadRegistered {
    static eventName() { return 'FileUploadRegistered'; }
    eventName = FileUploadRegistered.eventName;
    constructor(public transferId: string) {}
}